import {Text} from 'quickstart/components/content/Text'
import {Shape} from 'quickstart/components/layout/Shape'
import {withClassNames, withProps} from 'quickstart/theme'
import * as R from 'rambdax'
import S from './styles.module.css'

export const Cover = withClassNames(S.cover)(Shape)

export const Body = withClassNames(S.body)('div')

export const Heading = R.piped(
  Text,
  withProps({variant: 'headlineHead', prose: true}),
  withClassNames(S.heading),
)
